export default __webpack_public_path__ + "static/media/producteur.0b0240ce.png";